module.exports = __webpack_public_path__ + "img/IAR14.52f8a4fe.png";